import Main from '@/views/Main.vue';
import { ALLOWED_GAMES } from '../api/config';

const UserForm = () => import('@/views/UserForm.vue');

const Auth = () => import('@/views/Auth.vue');
const AuthCallback = () => import('@/views/AuthCallback.vue');
const NotExists = () => import('@/views/NotExists.vue');

const AccessDenied = () => import('@/views/error/AccessDenied.vue');
const UserNotFound = () => import('@/views/error/UserNotFound.vue');

export default [
  {
    path: '/login',
    name: 'authCallback',
    component: AuthCallback,
    meta: { requiresAnon: true },
  },
  {
    path: '/:app',
    name: 'main',
    component: Main,
    redirect: { name: 'user-form' },
    meta: { requiresAuth: true },
    beforeEnter: (to, _, next) => {
      if (to.params.app && ALLOWED_GAMES.includes(to.params.app)) {
        return next();
      }
      return next({ name: 'notExists' });
    },
    props: route => ({ app: route.params.app }),
    children: [
      {
        path: '',
        name: 'user-form',
        props: route => ({ app: route.params.app }),
        component: UserForm,
      },
      {
        path: '404',
        name: 'userNotFound',
        component: UserNotFound,
      },
      {
        path: '403',
        name: 'accessDenied',
        component: AccessDenied,
      },
    ],
  },
  {
    path: '/:app/auth',
    name: 'auth',
    component: Auth,
    props: route => ({ app: route.params.app }),
    beforeEnter: (to, _, next) => {
      if (to.params.app && ALLOWED_GAMES.includes(to.params.app)) {
        return next();
      }
      return next({ name: 'notExists' });
    },
    meta: { requiresAnon: true },
  },
  {
    path: '*',
    name: 'notExists',
    component: NotExists,
  },
];
